<template>
    <div class="app has-header">
        <div class="header main">
            
            <div class="align-left">
                <dateselectionheader
                    :label="yearDisplay"
                    @PrevDate="PreviousDate"
                    @NextDate="NextDate"
                    @CalendarOpen="toggleDatePicker"
                    @SetToday="SetDateToCurrentDay"/>
            </div>
            <div class="align-middle">
               <headerbuttonstack :state="headerButtons"/>
            </div>
            <div class="align-right">
            </div>
        </div>
        <div class ="tablecontainer scrollbar-container">
            <datatable :state="dataTableState"/>
        </div>  
      
      
    <div v-if="loading" class="loading-md bg">
            <i class="fas fa-spinner"></i>
            <div v-if="!$helpers.isEmpty(loadingText)" class="loading-text">
                {{ loadingText }}
            </div>
        </div>
  </div>

</template>

<script>
import datatable from '../uicomponents/datatable.vue';
import { mapState, mapGetters } from 'vuex';
export default {
  name: 'forecasttargetoverview',
    components: {
        datatable,
    },
  data () {
    return {

        error: false,
        loading: true,
        loadingText: null,
    }
  },
  
    created: function () {
        if(this.$store.state.jwt != undefined && this.$store.state.storeId != undefined){
            this.refresh();
        }
    },
    computed: {
        ...mapGetters(['storeId', 'rosterFromTo','storeSettings', 'isSuperUser', 'uiDataMap', 'planningIndicatorTypeMap', 'apiIntegrationDataMap', 'forecastTargetMap']),
        yearDisplay(){
            return ""+this.rosterFromTo.year;
        },
        headerButtons(){

            let view = this;

            let state= {
                buttons: []
            };
            //BUTTON 1
            state.buttons.push({
                type: "block",
                icon: "fa-sync-alt",
                click: () => {
                    view.refresh(true); 
                },
                tooltip: this.$t('global.general.refreshData')
            });
            
            state.helperLinks = [
                    {
                        title:  this.$t('store.structure.getSupport'),
                        helperText:  this.$t('store.structure.getSupportHelp'),
                        externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/2/create/13",
                        externalLabel:  this.$t('store.structure.getSupportLabel'),
                        cancelLabel: this.$t('global.ui.close'),
                    }
                ];
            return state;
        },
        indicatorCategoryMap(){
            let map = {};
            Object.values(this.uiDataMap.planningIndicatorTypeCategories).forEach(i => {
                map[i.id] = i;
            });
            return map;
        },
        
        dataTableState(){
            let view = this;
            
            let state = {};
            
            let values = Object.values(this.forecastTargetMap)
            .sort((a, b) => {
                if(a.category < b.category) return -1;
                if(a.category > b.category) return 1;
                if(a.year < b.year) return -1;
                if(a.year > b.year) return 1;
                if(a.month < b.month) return -1;
                if(a.month > b.month) return 1;
                return 0;
            });
            
            state = this.$helpers.GetDataTableStateFromObject({year: '', month: '', category: '', amount: ''},values);
            state.headerMap['year'].sort = false;
            state.headerMap['year'].label = "Jahr";
            
           

            state.headerMap['month'].sort = false;
            state.headerMap['month'].label = "Monat";
            state.headerMap['month'].DisplayLabel = (i) => {
                
                return view.$t('global.general.month' + i.month);
                
            };

            state.headerMap['category'].sort = false;
            state.headerMap['category'].label = 'Kategorie';
            state.headerMap['category'].align = 'center';
            state.headerMap['category'].DisplayLabel = (i) => {return view.indicatorCategoryMap[i.category] ? view.indicatorCategoryMap[i.category].label_de : "-"};
            

            state.headerMap['amount'].sort = false;
            state.headerMap['amount'].label = 'Betrag';
            state.headerMap['amount'].align = 'center';
            
            
            state.headerMap['actions'] = {align: 'center',
                button: {icon: 'fas fa-plus', action: ($event, data) => view.OpenCreateForecastTargetModal($event)},
                buttons:[
                    {icon: 'fas fa-edit', action: ($event, data) => view.OpenEditForecastTargetModal($event, data)}, 
                    {icon: 'fas fa-trash', action: ($event, data) => view.OpenDeleteForecastTargetModal($event, data)},
                ]
            };
            
            state.headerMap['actions'].width = '100px';
            
            
            return state;
        },
    },
    watch: { 
        storeId: function(val, oldVal) {
            this.refresh(true);
        },
        rosterFromTo: function(val, oldVal) {
            this.refresh(true);
        },
    },
  // methods that implement data logic.
    methods: {
        PreviousDate(){
            let date = this.$helpers.getMomentTZ().year(this.rosterFromTo.year).month(this.rosterFromTo.month).date(1).startOf('day');
            date = date.add(-1, 'years');
            this.setDateSelection(date);
        },
        NextDate(){
            let date = this.$helpers.getMomentTZ().year(this.rosterFromTo.year).month(this.rosterFromTo.month).date(1).startOf('day');
            date = date.add(1, 'years');
            this.setDateSelection(date);
        },
        SetDateToCurrentDay(){
            this.date = this.$helpers.getMomentTZ().startOf('day');
        },
        toggleDatePicker($event) {
            let view = this;
            let d = this.$helpers.getMomentTZ().year(this.rosterFromTo.year).month(this.rosterFromTo.month).date(1);
            this.$helpers.OpenDatepickerPopup(
                { viewsEnabled: ['Y'], date: d.clone() },
                {OnDateSelect: (date) => { view.setDateSelection(date) },},
                { elRelative: $event ? $event.currentTarget : null });
        },
        setDateSelection(date) {
            //update vuex store with calculated from to => triggers reload of data via refresh
            let rosterFromTo = this.$helpers.CalculateRosterFromTo(date);
            this.$store.commit('setRosterFromTo', {
                rosterFromTo: rosterFromTo
            });
            
            this.$forceUpdate();
        },
        onDatePicked(date){
            this.date = date.startOf('year');

        },
        refresh: function(force = false) {
            let view = this;
            this.loading = true;
            view.$helpers.GetPlanningIndicatorTypeMap(force)
            .then(map=>{
                return view.$helpers.GetForecastTargetMap(force);
            })
            .then(map=>{
                return view.$helpers.GetApiIntegrationDataMap(force);
            })
            .then(map=>{
                view.loading = false;
            })
            .catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.dataLoadingError'));
                view.loading = false;
                console.log(error)
            });
        },
        OpenCreateForecastTargetModal($event){
            let view = this;
            let monthItems = [
                {label: this.$t('global.general.month1'), value: 1},
                {label: this.$t('global.general.month2'), value: 2},
                {label: this.$t('global.general.month3'), value: 3},
                {label: this.$t('global.general.month4'), value: 4},
                {label: this.$t('global.general.month5'), value: 5},
                {label: this.$t('global.general.month6'), value: 6},
                {label: this.$t('global.general.month7'), value: 7},
                {label: this.$t('global.general.month8'), value: 8},    
                {label: this.$t('global.general.month9'), value: 9},
                {label: this.$t('global.general.month10'), value: 10},
                {label: this.$t('global.general.month11'), value: 11},
                {label: this.$t('global.general.month12'), value: 12},  
            ]
            let categoryItems = Object.values(this.indicatorCategoryMap).map(i => {
                return {label: i.label_de, value: i.id};
            }).filter(i => i.value == 2 || i.value == 3);

            view.$helpers.OpenPopup({
                elRelative: $event.currentTarget,
                type: 'datafill',
                componentState: {
                    entries: [
                        {label: 'Jahr', key: 'year', hidden: false, disabled: true, type: 'numeric', value: this.rosterFromTo.year},
                        {label: 'Monat', key: 'month', hidden: false, type: 'dropdownsearch', value: null, dropdownSearchState:{
                                toggled: false,
                                displayedItems: [],
                                input: '',
                                items: monthItems,
                                selectMultiple: false,
                                selectedItems: [],
                                selectFirst: true,
                                styleLight: true,
                        }},
                        {label: 'Kategorie', key: 'category', hidden: false, type: 'dropdownsearch', value: null, dropdownSearchState:{
                                toggled: false,
                                displayedItems: [],
                                input: '',
                                items: categoryItems,
                                selectMultiple: false,
                                selectedItems: [],
                                selectFirst: true,
                                styleLight: true,
                        }},
                        {label: 'Betrag', key: 'amount', hidden: false, type: 'numeric', value: 0},
                    ],
                    selectCallback: function (data) {
                        let payload = {
                            year: data.year,
                            month: data.month,
                            category: data.category,
                            amount: parseFloat(data.amount),
                        };
                        view.createForecastTarget(data);
                    }
                },
                header: this.$t('indicator.main.addForecastTarget'),
                centered: true,
                expanded: true,
            });
        },
        createForecastTarget: function(item){
            let view = this;
            let url = '/api/sec/forecasttarget';
            let params = {
                storeId: this.storeId,
            }


            let payload = {
                storeId: this.storeId,
                year: item.year,
                month: item.month,
                category: item.category,
                amount: item.amount,
            };

            this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                params: params,
                data: payload
            }).then(response => {
                view.$store.commit("setForecastTargetMapEntry", response.data.data);
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('indicator.main.addForecastTargetSuccess'));
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('indicator.main.addForecastTarget'));
                console.log(error)
            })

        },
        
        OpenDeleteForecastTargetModal($event, data){
            let view = this;
            view.$helpers.OpenAlert({header: this.$t('indicator.main.deleteForecastTarget'), description: this.$t('indicator.main.deleteForecastTargetQuery'), callbackAccept: (alert) => {
                alert.hidden = true;
                view.deleteForecastTarget(data);
            }});
        },
        deleteForecastTarget: function(item){
            let view = this;
            let url = '/api/sec/forecasttarget';
            let params = {
                id: item.id,
                storeId: this.storeId,
            }
           

            this.axios({
                method: 'delete',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                params: params,
                url: url
            }).then(response => {
                view.$store.commit("deleteForecastTargetMapEntry", {id: item.id});
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('indicator.main.deleteForecastTargetSuccess'));
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('indicator.main.deleteForecastTargetError'));
                console.log(error)
            })

        },
        OpenEditForecastTargetModal($event, item){
            let view = this;
            let monthItems = [
                {label: this.$t('global.general.month1'), value: 1},
                {label: this.$t('global.general.month2'), value: 2},
                {label: this.$t('global.general.month3'), value: 3},
                {label: this.$t('global.general.month4'), value: 4},
                {label: this.$t('global.general.month5'), value: 5},
                {label: this.$t('global.general.month6'), value: 6},
                {label: this.$t('global.general.month7'), value: 7},
                {label: this.$t('global.general.month8'), value: 8},    
                {label: this.$t('global.general.month9'), value: 9},
                {label: this.$t('global.general.month10'), value: 10},
                {label: this.$t('global.general.month11'), value: 11},
                {label: this.$t('global.general.month12'), value: 12},  
            ]
            let selectedMonth = monthItems.find(i => i.value == item.month);
            if(!selectedMonth){
                selectedMonth = monthItems[0];
            }
            selectedMonth.selected = true;
            let categoryItems = Object.values(this.indicatorCategoryMap).map(i => {
                return {label: i.label_de, value: i.id};
            }).filter(i => i.value == 2 || i.value == 3);
            let selectedCategory = categoryItems.find(i => i.value == item.category);
            if(!selectedCategory){
                selectedCategory = categoryItems[0];
            }
            selectedCategory.selected = true;
           
            this.$helpers.OpenPopup({
                elRelative: $event.currentTarget,
                type: 'datafill',
                componentState: {
                    entries: [
                        {label: 'Id', key: 'id', hidden: true, type: 'text', value: item.id},
                        {label: 'Jahr', key: 'year', hidden: false, disabled: true, type: 'numeric', value: item.year},
                        {label: 'Monat', key: 'month', hidden: false, type: 'dropdownsearch', value: item.month, dropdownSearchState:{
                                toggled: false,
                                displayedItems: [],
                                input: '',
                                items: monthItems,
                                selectMultiple: false,
                                selectedItems: [selectedMonth],
                                selectedItem: selectedMonth,
                                selectFirst: false,
                                styleLight: true,
                        }},
                        {label: 'Kategorie', key: 'category', hidden: false, type: 'dropdownsearch', value: item.category, dropdownSearchState:{
                                toggled: false,
                                displayedItems: [],
                                input: '',
                                items: categoryItems,
                                selectMultiple: false,
                                selectedItems: [selectedCategory],
                                selectedItem: selectedCategory,
                                selectFirst: false,
                                styleLight: true,
                        }},
                        {label: 'Betrag', key: 'amount', hidden: false, type: 'numeric', value: item.amount},
                       
                    ],
                    selectCallback: function (item) {
                        view.editForecastTarget(item);
                    },
                    
                },
                header: this.$t('indicator.main.editForecastTarget'),
                centered: true,
                expanded: true,
            });
        },
        editForecastTarget: function(item){
            let view = this;
            let url = '/api/sec/forecasttarget';
            let params = {
                
                storeId: this.storeId,
            }

            let payload = {
                id: item.id,
                year: item.year,
                month: item.month,
                category: item.category,
                amount: item.amount,
                updateFields: ["year, month", "category", "amount"],
            };

            this.axios({
                method: 'put',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                params: params,
                data: payload
            }).then(response => {
                let data = view.forecastTargetMap[item.id]
                data.year = payload.year;
                data.month = payload.month;
                data.category = payload.category;
                data.amount = payload.amount;
                

                view.$store.commit("setForecastTargetMapEntry", data);
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('indicator.main.editForecastTargetSuccess'));
            }).catch(function (error) {
               view.$helpers.error(view.$t('global.notifications.error'), view.$t('indicator.main.editForecastTargetError'));
               console.log(error)
            })

        },
        
        
        
    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .tablecontainer{
        padding-left: 30px;
        padding-right: 30px;
    }
 
    .has-header > .has-header > .scrollbar-container{
        height: calc(100% - var(--header-height) - var(--tab-menu-height)) !important;
        top: var(--header-height);
    }
    .header.top{
        margin: 10px 0;
    }
    .data-table{
        top: 10px;
        position: relative;
    }

    .header.date{
        display: inline-flex;
        justify-items: center;
        align-items: center;
        position: absolute;
        left: 20px;
    }

    .header.date .label{
        color: var(--contrast-4);
        font-family: DistrictProLight;
        font-weight: 200;
        margin-top: -3px;
    }

    .header.date .label.bold{
        font-family: DistrictProBold;
        font-weight: 800;
        margin-right: 5px;
        margin-top: -3px;
    }

    .header.date .fa-calendar{
        margin: 0 10px;
        font-size: 20px;
        margin-top: -3px;
    }
    .header.date .fa-angle-left{
        margin: 0 10px;
        font-size: 25px;
        color: var(--contrast-4);
    }
    .indicator-view{
        padding: 30px;
        padding-bottom: 50px;
    }
</style>
